import React, { useState } from "react";

import Cart from "../../modules/cart/CartController.jsx";
import { Provider } from "../../components/login/LoginController.jsx";
import Shop from "../../modules/shop/ShopController.jsx";
import { IntlProviderWrapper } from "./IntlContext";

export default Provider(App);

function App(props) {
  const [delivery, setDelivery] = useState(props.delivery || {});
  return (
    <IntlProviderWrapper {...props}>
      <div className="app">
        {props.ownerlessShop && props.ownerlessShop === true ? (
          <Shop {...props} delivery={delivery} setDelivery={setDelivery} />
        ) : (
          <Cart {...props} delivery={delivery} setDelivery={setDelivery} />
        )}
      </div>
    </IntlProviderWrapper>
  );
}
